module.exports = __webpack_public_path__ + "img/sample-01.4125caa6.png";